/** Members and invitations go through Better Auth's organization plugin (a workspace is an organization). */
import type { Role } from "@sp/shared/enums";
import { request, seg } from "./http";
import type { FullWorkspace, Invitation, InvitationDetail } from "./types";

export const membersApi = {
  workspace: (workspaceId: string, signal?: AbortSignal) =>
    request<FullWorkspace>("GET", `/api/auth/organization/get-full-organization?organizationId=${seg(workspaceId)}`, undefined, { signal }),
  invite: (workspaceId: string, email: string, role: Role) =>
    request<Invitation>("POST", "/api/auth/organization/invite-member", { organizationId: workspaceId, email, role }),
  cancelInvite: (invitationId: string) => request<unknown>("POST", "/api/auth/organization/cancel-invitation", { invitationId }),
  changeRole: (workspaceId: string, memberId: string, role: Role) =>
    request<unknown>("POST", "/api/auth/organization/update-member-role", { organizationId: workspaceId, memberId, role }),
  remove: (workspaceId: string, memberId: string) =>
    request<unknown>("POST", "/api/auth/organization/remove-member", { organizationId: workspaceId, memberIdOrEmail: memberId }),
  leave: (workspaceId: string) => request<unknown>("POST", "/api/auth/organization/leave", { organizationId: workspaceId }),

  invitation: (id: string, signal?: AbortSignal) =>
    request<InvitationDetail>("GET", `/api/auth/organization/get-invitation?id=${seg(id)}`, undefined, { signal }),
  accept: (invitationId: string) => request<unknown>("POST", "/api/auth/organization/accept-invitation", { invitationId }),
  reject: (invitationId: string) => request<unknown>("POST", "/api/auth/organization/reject-invitation", { invitationId }),
};
